module.exports = __webpack_public_path__ + "img/waistline upper pocket position.3e1d93ba.png";